<template>
  <div>
    <app-time-row-create
      @timeRowCreated="createTimeRow">
    </app-time-row-create>
  </div>
</template>

<script>
import TimeRowCreate from '../components/TimeRowCreate.vue';

export default {
  components: {
    'app-time-row-create': TimeRowCreate,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    createTimeRow(newTimeRow) {
      this.$store.dispatch('createTimeRow', newTimeRow)
        .then((response) => {
          if (response) {
            this.$router.push({ path: '/' });
          }
        });
    },
  },
};
</script>
